import React from 'react';
import {Link, Outlet} from 'react-router-dom'
import ThemeSwitcher from '../../components/molecules/ThemeSwitcher'
import {InnerContainer} from '../../components/atoms/Containers'
import Grid from '@/components/molecules/Grid';
import styled from 'styled-components';
import {device} from '@/styles/template';

interface Props {

}

const navData = [
    {
        title: 'Main',
        link: `/`,
    },
    {
        title: 'Colors',
        link: `/designsystem/colors`,
    },
    {
        title: 'Icons',
        link: `/designsystem/icons`,
    },
    {
        title: 'Object Styles',
        link: `/designsystem/objectstyles`,
    },
    {
        title: 'Fonts',
        link: `/designsystem/fonts`,
    },
    {
        title: 'Buttons',
        link: `/designsystem/buttons`,
    },
    {
        title: 'Forms',
        link: `/designsystem/forms`,
    },

    {
        title: 'Charts',
        link: `/designsystem/charts`,
    },
    {
        title: 'Samples',
        link: `/designsystem/samples`,
    },

    {
        title: 'Article Content',
        link: `/designsystem/article`,
    },

    {
        title: 'Testing Design',
        link: `/designsystem/testing`,
    },
];

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 5rem;
  width: 100%;
  position: relative;
  @media ${device.tablet} {
    grid-template-columns: minmax(100px, max-content) minmax(400px, 1fr);
  }
`;


const StickyMenu = styled.div`
    @media ${device.tablet} {
        position: sticky;
    }
   
    height: fit-content;
    top: 0;
`;

const DesignSystem: React.FC<Props> = () => {
    return (
        <>
            <InnerContainer>
                <GridContainer>
                    <StickyMenu>
                        <Grid col='1' gap='2' margin='6' >
                            <ThemeSwitcher />
                            <nav>
                                <ul>
                                    {navData.map((item: any, index: any) => {
                                        return <li key={index}>
                                            <Link to={item.link}>{item.title}</Link>
                                        </li>
                                    })}
                                </ul>
                            </nav>
                        </Grid>
                    </StickyMenu>

                    <Outlet />
                </GridContainer>

            </InnerContainer>

        </>
    )
}

export default DesignSystem